/*
 * File: CustomModal.tsx
 * Project: a-a
 * File Created: Monday, 4th November 2024 11:59:25 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 15th April 2025 12:35:33 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import zeplinColor from '../../../theme/Color';

type CustomModalProp = {
  open?: boolean;
  handleCloseModal?: () => void;
};

const CustomLoader = ({ open = false, handleCloseModal }: CustomModalProp) => {
  return (
    <Modal
      open={open}
      // onClose={handleCloseModal}
      aria-labelledby='modal-modal-title'
      //   aria-describedby='modal-modal-description'
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // position: 'relative',
        zIndex: 100,

        // height: '100vh',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '14px',
          width: '156px',
          height: '56px',
          backgroundColor: zeplinColor.Neutral1,
          padding: '24px',
          gap: '12px',

          '&:focus': {
            outline: 'none', // Removes the blue outline
          },
        }}
      >
        {/* <Typography id='modal-modal-title' variant='h6' component='h2'>
          Text in a modal
        </Typography> */}
        <CircularProgress sx={{ color: zeplinColor.BasicBlack }} size={'18px'} />
        <Typography id='modal-modal-title' variant='body2' sx={{ color: zeplinColor.BasicBlack }}>
          Loading...
        </Typography>
      </Box>
    </Modal>
  );
};

export default CustomLoader;
